export function safePostAuthRedirect(search: string): string {
  const requested = new URLSearchParams(search).get("redirect_url");
  return requested?.startsWith("/") &&
    !requested.startsWith("//") &&
    !requested.startsWith("/sign-in") &&
    !requested.startsWith("/sign-up")
    ? requested
    : "/dashboard";
}

export function signInUrlForLocation(location: string): string {
  const returnTo = location.startsWith("/") && !location.startsWith("//")
    ? location
    : "/dashboard";
  return `/sign-in?redirect_url=${encodeURIComponent(returnTo)}`;
}